import { useEffect } from 'react';
import '../App.css'

export const Settings = ({ data }) => {

    return (
        <div className='content'>Settings {data}</div>
    )
};